import _ from 'lodash';
import {connect as _connect} from 'react-redux';

function reducerAndActionsFor(superType, payloadGetters) {
  var actionsData = _.mapValues(payloadGetters, (getPayload, subType) => {
    return {
      getPayload,
      type: `${superType}.${subType}`,
      isAsync: getPayload.constructor === (async function () {}).constructor
    };
  });

  var actions = _.mapValues(actionsData, ({type, getPayload, isAsync}) => {
    // return ({dispatch, isAsync}) => {
      return (props) => {
        return (dispatch, getState) => {
          var prevState = _.get(getState(), superType);

          if (isAsync) {
            (async () => {
              var _getPayload = async () => await getPayload({getState, prevState, [superType]: prevState, ...props});

              dispatch({type: `${type}.begin`, payload: {...prevState, isLoading: true}});
              
              try {
                var payload = await _getPayload();
                
                dispatch({type: `${type}.success`, payload: {isLoading: false, ...payload}});
              }
              catch (error) {
                console.error(error); //eslint-disable-line
  
                dispatch({type: `${type}.failure`, payload: {isLoading: false}});
  
                throw error;
              }
            })();
          }
          else {
            var _getPayload = () => getPayload({getState, prevState, [superType]: prevState, ...props});

            dispatch({type, payload: _getPayload()});
          }
        };
      };
    // };
  });

  var reducer = (state={}, action) => {
    var {type: t} = action;

    _.forEach(actionsData, ({type}) => {
      if (t === `${type}.begin` || t === `${type}.success` || t === `${type}.failure` || t === type) {
        state = {...action.payload};
      }
    });

    return state;
  };

  return {actions, reducer};
};

function connect({mapState, mapDispatch}) {
  var mapStateToProps = (state) => {
    var props = _.pick(state, ['session']);

    if (mapState) {
      if (_.isFunction(mapState)) {
        props = {...props, ...mapState(state)};
      }
      else {
        _.forEach(mapState, statePath => {
          props = {...props, [statePath]: _.get(state, statePath)};
        });
      }
    }

    return props;
  };

  var mapDispatchToProps = (dispatch) => {
    var props = {};

    if (mapDispatch) {
      if (_.isFunction(mapDispatch)) {
        props = {...props, ...mapDispatch(dispatch)};
      }
      else {
        props = {...props, ..._.mapValues(mapDispatch, action => {
          return (...args) => dispatch(action(...args));
        })};
      }
    }

    return props;
  };

  return _connect(mapStateToProps, mapDispatchToProps);
};

export {connect, reducerAndActionsFor};
